module.exports = __webpack_public_path__ + "img/trifold.8157682c.jpg";